import { push } from "connected-react-router";
import { call, put, take } from "redux-saga/effects"
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment'
import actionTypes from "../../actions/actionTypes"
import { putError, putSuccess } from "../helpers";
import config from '../../config.json'
import { getFromWeekCinemaStartDate } from "../../functions/getDateFromWeek";


function* createCollections(cinema) {
    const currentCW = yield moment().isoWeek()
    const weeks = yield [currentCW , currentCW + 1, currentCW + 2]
    const collections = yield []

    for(let i = yield 0; yield i < 3; yield i++) {
        const week = yield weeks[i]
        const startDate = yield getFromWeekCinemaStartDate(week, 2023)
        const endDate = yield moment(startDate).add(6, 'days')
        const collectioPk = yield uuidv4() 

        const collection = yield {
            pk: collectioPk,
            edited: false,
            cinema: cinema,
            edited: false,
            dateStart: startDate,
            dateEnd: endDate,
            items: []
        }

        yield put({
            type: actionTypes.SIGNAGE_COLLECTION_CREATE,
            payload: {
                pk: collectioPk,
                data: collection
            }
        })

        yield collections.push(collection)
    }

    return yield collections
}

function* createScreen(screenData, collections) {
    const screenPk = yield uuidv4() 
    const collectionPks = yield []
    const scheme = yield []

    for(let i = yield 0; yield i < collections.length; yield i++) {
        const collection = yield collections[i]

        yield scheme.push({
            dateStart: collection.dateStart,
            dateEnd: collection.dateEnd,
            timeFilters: [{
                startTime: '00:00:00',
                endTime: '23:59:59',
                collection: collection.pk
            }]
        })

        yield collectionPks.push(collection.pk)
    }

    yield put({
        type: actionTypes.SIGNAGE_SCREEN_CREATE,
        payload: {
            pk: screenPk,
            data: {
                pk: screenPk,
                collections: collectionPks,
                scheme: scheme,
                ... screenData
            }
        }
    })
}

function* create(data) {
    try {
        if(!data || !data.hasOwnProperty('screenData') || !data.screenData) {
            throw new Error()
        }

        const collections = yield call(createCollections, data.screenData.cinema)
        yield call(createScreen, data.screenData, collections)
        yield put(push(config.routes.signage.path))
        yield call(putSuccess, actionTypes.SIGNAGE_SCREEN_CREATE_SUCCESS, {})
    } catch(e) {
        yield call(putError, actionTypes.SIGNAGE_SCREEN_CREATE_ERROR, e.message)
    }
}

function* watchSignageScreenCreateRequest() {
    try {
        while(true) {
            const request = yield take(actionTypes.SIGNAGE_SCREEN_CREATE_REQUEST)

            yield call(create, request.payload)
        }

    } catch(e) {
        console.log('eeee', e)
        console.log('error!!!!!', e.message)
    }
}

export default watchSignageScreenCreateRequest